import { Language } from './language.enum';

export class Constants {
  public static readonly defaultLanguage = Language.de;
  public static readonly languageHeaderName = 'Preferred-Language';
  public static readonly filePrefix = 'file://';
}
